import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Headphones, ArrowUpRight } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative" data-testid="main-footer">
      {/* Main Footer */}
      <div className="bg-[var(--charcoal)] text-white">
        <div className="container-premium py-20 lg:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 lg:gap-12">
            {/* Brand Column */}
            <div>
              <div className="mb-8">
                <h2 className="font-display text-3xl font-bold">
                  ALMA <span className="text-[var(--terracotta)]">VIVU</span>
                </h2>
              </div>
              <p className="text-white/70 text-sm leading-loose mb-6">
                Accompagnement au changement de comportement des adultes de demain pour favoriser la compréhension et la mobilisation autour des enjeux environnementaux et sociaux en Corse.
              </p>
              <p className="text-white/50 text-xs mb-8">
                SIRET : 107 819 575 00013
              </p>
              {/* Podcast Badge */}
              <a 
                href="https://open.spotify.com/show/52wol3hDjDzCs9KyYbX06j" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/15 rounded-full px-5 py-3 transition-colors group"
              >
                <Headphones className="w-5 h-5 text-[var(--terracotta)]" />
                <div>
                  <p className="text-sm font-semibold">Maquis Vivant</p>
                  <p className="text-xs text-white/50">Le podcast</p>
                </div>
                <ArrowUpRight className="w-4 h-4 text-white/50 group-hover:text-white transition-colors" />
              </a>
            </div>

            {/* Navigation Column */}
            <div>
              <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--terracotta)] mb-8">
                Navigation
              </h4>
              <ul className="space-y-5">
                {[
                  { path: "/", label: "Accueil" },
                  { path: "/design-durable", label: "A Propos" },
                  { path: "/innovation-responsable", label: "Méthodologie" },
                  { path: "/podcast", label: "Outils" },
                  { path: "/strategie-rse", label: "Domaines d'Intervention" },
                  { path: "/strategie-climat", label: "Ressources Utiles" },
                  { path: "/contact", label: "Contact" },
                ].map((link) => (
                  <li key={link.path}>
                    <Link 
                      to={link.path} 
                      className="text-white/70 hover:text-white transition-colors flex items-center gap-2 group"
                    >
                      <span className="w-1.5 h-1.5 bg-[var(--terracotta)] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Column */}
            <div>
              <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--terracotta)] mb-8">
                Contact
              </h4>
              <ul className="space-y-7">
                <li>
                  <a 
                    href="tel:0751131092" 
                    className="flex items-center gap-4 text-white/70 hover:text-white transition-colors group"
                  >
                    <div className="w-10 h-10 bg-white/10 group-hover:bg-[var(--terracotta)] rounded-xl flex items-center justify-center transition-colors">
                      <Phone className="w-5 h-5" />
                    </div>
                    <div>
                      <p className="text-xs text-white/50 uppercase tracking-wider">Téléphone</p>
                      <p className="font-medium">07 51 13 10 92</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a 
                    href="mailto:maud.almavivu@gmail.com" 
                    className="flex items-center gap-4 text-white/70 hover:text-white transition-colors group"
                  >
                    <div className="w-10 h-10 bg-white/10 group-hover:bg-[var(--terracotta)] rounded-xl flex items-center justify-center transition-colors">
                      <Mail className="w-5 h-5" />
                    </div>
                    <div>
                      <p className="text-xs text-white/50 uppercase tracking-wider">Email</p>
                      <p className="font-medium">maud.almavivu@gmail.com</p>
                    </div>
                  </a>
                </li>
                <li>
                  <div className="flex items-start gap-4 text-white/70">
                    <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-5 h-5" />
                    </div>
                    <div>
                      <p className="text-xs text-white/50 uppercase tracking-wider mb-1">Localisation</p>
                      <p className="font-medium leading-relaxed">
                        Basée sur Ajaccio et intervient sur toute la Corse
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10">
          <div className="container-premium py-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              <p className="text-sm text-white/50">
                © {currentYear} ALMA VIVU — Ajaccio, Corse • Tous droits réservés • Création{" "}
                <a href="https://www.webisula.com/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">WEBISULA</a>
              </p>
              <div className="flex items-center gap-8">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors">
                  Mentions légales
                </a>
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors">
                  Confidentialité
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
